export const getErrorFromAssignResponse = (error) =>  {
    let errorMessage = "Failed to assign caregivers";
    let secondaryMessage = "";

    if (typeof error.details === "string" && error.error === `Conflict: ${error.details}`) {
        secondaryMessage = error.details;
    }

    if (error.status && error.status === 403 && error.type === "AssignWithOvertimeError") {
        errorMessage = "Not permitted to increase caregiver overtime.";
    }

    if(error.type !== undefined){
        switch(error.type){
            case "AssignWithOvertimeError":{
                errorMessage = "Not permitted to increase caregiver overtime.";
                break;
            }
            case "WeeklyTemplateAdjustmentError":{
                errorMessage = "Could not adjust weekly template";
                secondaryMessage = error.reasons.length > 0 ? error.reasons.at(0) : "";
                break;
            }
            case "OfficeHoursRestrictionsConflict": {
                errorMessage = "Office hours restrictions conflict";
                break;
            }
            case "CargeiverVisitOverlap": 
            case "VisitsOverlapError": {
                errorMessage = "This assignment overlaps with patient or caregiver existing visits";
                break;
            }
            case "InactiveCaregiverAssignement": {
                errorMessage = "Can't assign inactive caregiver";
                break;
            }
            default: {
                errorMessage = "Failed to assign caregivers";
                break;
            }
        }
    }

    const isPatientStatusConflict =
        error.details === "Patient must be active before a caregiver request can be approved or the broadcast assigned." &&
        error.error === `Conflict: ${error.details}`;

    if (isPatientStatusConflict) {
        errorMessage = "Cannot accept or assign this case";
        secondaryMessage = "On-hold and other inactive cases cannot be accepted or assigned. Change the patient status to Active first.";
    }

    return {
        toastType: isPatientStatusConflict ? "warning" as const : "error" as const,
        errorMessage,
        secondaryMessage
    };
}
